// extracted by mini-css-extract-plugin
export default {"loader":"OpacityComparison_loader__9WtoE","rotation":"OpacityComparison_rotation__AgARu"};